var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73828 2.40039H18.26V17.6004H1.73828V2.40039Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 4H16.522V6.08333H3.47852V4Z",
    fill: "#006DC5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47852 6.9502H9.13069V15.8338L3.47852 15.8338V6.9502ZM10.8698 6.9502H16.522V15.8338L10.8698 15.8338V6.9502Z",
    fill: "#55A7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateFile);
export default __webpack_public_path__ + "static/media/template-file.445cd286a448d44077a7122511f274bd.svg";
export { ForwardRef as ReactComponent };